import {Component} from "@angular/core";
import {AdminService} from "../../services/admin.service";
import {SharedService} from "../../services/sharedService";
import {DocumentService} from "../../services/document.service";
import {ToastrService} from "ngx-toastr";
import {saveAs} from 'file-saver';

const KEY = 'HOME_HELP_TEXT';

@Component({
    selector: 'app-help',
    template: `
        <div class="container-fluid">
            <div class="container-fluid p-t-xlg" (click)="onContentClick($event)">
                <div [innerHtml]="helpContent | keepHtml"></div>
            </div>
        </div>
    `
})
export class HelpComponent {

    helpContent: any;

    constructor(private settings: AdminService,
                private shared: SharedService,
                private documentService: DocumentService,
                private toastr: ToastrService) {
        this.shared.getLan$().subscribe(lan => {
            console.debug('Language changed to -> ', lan);
            this.loadHelpText();
        });
        this.loadHelpText();
    }

    loadHelpText() {
        this.settings.getAdminSettings().subscribe(settings => {
            if (settings && settings.length > 0)
                this.helpContent = settings[0]?.[KEY]?.[this.shared.getLan()] || 'No help text available';
            else
                this.helpContent = 'No help text available';
        });
    }

    onContentClick(event: MouseEvent): void {
        const target = event.target as HTMLElement;
        const anchor = target.closest('a[data-document-id]') as HTMLAnchorElement;
        if (!anchor) return;

        event.preventDefault();
        const docId = anchor.getAttribute('data-document-id');
        if (!docId) return;
        const filename = anchor.textContent?.trim() || 'document';

        this.documentService.get$(docId).subscribe(
            (blob: Blob) => { saveAs(blob, filename); },
            () => { this.toastr.error('File not found or has been removed.'); }
        );
    }
}
